// import './polyfill'
import 'regenerator-runtime/runtime'
import 'core-js/stable'
import Vue from 'vue'
import CoreuiVue from '@coreui/vue'
import App from './app/App'
import router from '@/app/router/index'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
// import './gtm.js';
import '@/app/shared/utils/filters';
import Embed from 'v-video-embed';

import moment from 'moment'


import * as VueGoogleMaps from 'vue2-google-maps'
import { GMAPS_KEY, RECAPTCHA_KEY, GTM_CODE }  from '@/config';
Vue.use(VueGoogleMaps, {
  load: {
    key: GMAPS_KEY,
    libraries: 'places',
  }
});
import { VueReCaptcha } from "vue-recaptcha-v3";
Vue.use(VueReCaptcha, { siteKey: RECAPTCHA_KEY});

import VueCryptojs from 'vue-cryptojs'

import VueGtm from '@gtm-support/vue2-gtm';
Vue.use(VueGtm, {
  id: GTM_CODE,
  // defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
  compatibility: true, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
  // nonce: '2726c7f26c', // Will add `nonce` to the script tag
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: false, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  // ignoredViews: ['homepage'], // Don't trigger events for specified router names (optional)
  // trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
  // queryParams: {
  //   // Add URL query string when loading gtm.js with GTM ID (required when using custom environments)
  //   gtm_auth: 'AB7cDEf3GHIjkl-MnOP8qr',
  //   gtm_preview: 'env-4',
  //   gtm_cookies_win: 'x',
  // },
});

// Requires styles
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

// import Vuelidate from 'vuelidate'
// Vue.use(Vuelidate)

import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import Toast from "@/app/shared/components/Toast";
import DeleteModal from '@/app/shared/components/modals/DeleteModal';
import ConfirmationModal from '@/app/shared/components/modals/ConfirmationModal';
import SpinnerTtt from '@/app/shared/components/SpinnerTtt';
import SpinnerCircle from '@/app/shared/components/SpinnerCircle';
import dayjs from 'dayjs'
Vue.use(dayjs)
Vue.component('multiselect', Multiselect);
Vue.component('toast', Toast);
Vue.component('DeleteModal', DeleteModal);
Vue.component('ConfirmationModal', ConfirmationModal);
Vue.component('date-picker', DatePicker);
Vue.component('SpinnerTtt', SpinnerTtt);
Vue.component('SpinnerCircle', SpinnerCircle);

moment.locale('es');

Vue.use(VueCryptojs);

Vue.use(CoreuiVue)
Vue.prototype.$log = console.log.bind(console)

window.moment = moment;
// window.router = router;

Vue.use(Embed);

new Vue({
  el: '#app',
  router,
  store,
  //CIcon component documentation: https://coreui.io/vue/docs/components/icon
  icons,
  template: '<App/>',
  components: {
    App
  }
})
